<template>
  <section ref="sectionRef" class="meet-tobias-section w-full min-h-screen pt-[4rem] mt-[4rem] lg:mt-0 lg:pt-[10rem] px-5 lg:px-32 relative" style="z-index: 1;">
    <div class="w-full flex flex-col lg:flex-row lg:items-center lg:justify-between relative lg:w-5/5">
      <!-- Left Column -->
      <div class="flex flex-col lg:gap-8 w-full lg:w-2/5 z-[99]">
        <h2 ref="titleRef" class="text-white font-[500] text-[30px] lg:text-[5vw] xl:text-[80px] whitespace-nowrap">Meet Tobias.</h2>

        <!-- Mobile Content -->
        <div
            ref="mobileContentRef"
            class="lg:hidden relative mt-[1.5rem] z-[-1]"
            style="overflow: hidden;"
        >
          <div
              :style="{ height: mobileContentHeight }"
              class="mobile-content-inner"
          >
            <div ref="mobileTextRef" class="w-2/3 absolute top-0 left-0 transform-gpu">
              <p class="text-white text-[12px] leading-[1.5]">
                Tobias has spent over $250 million across every digital platform. Building omni-funnel, multi-touchpoint performance strategies for some of the world's biggest brands.
              </p>
            </div>
            <!-- SVG with Text -->
            <div ref="svgContainerRef" class="mobile-svg-container absolute top-0 left-0 w-full transform-gpu">
              <svg class="responsive-svg" fill="none" viewBox="0 0 366 252" xmlns="http://www.w3.org/2000/svg">
                <g filter="url(#filter0_d_121_1693)">
                  <path d="M314.727 7.57549L358.88 55.4363C360.243 56.9139 361 58.8505 361 60.8608V239C361 243.418 357.418 247 353 247H13C8.58173 247 5 243.418 5 239V13C5 8.58172 8.58173 5 13 5H308.847C311.08 5 313.212 5.93379 314.727 7.57549Z" fill="#161816"/>
                </g>
                <foreignObject height="200" width="320" x="20" y="20">
                  <div class="svg-text">
                    <p class="text-white text-[12px] leading-[1.5]">
                      "The landscape of Meta and D2C growth has transformed exponentially in the last 12 months. Gone are the days of relying on magic setups and percentage-of-ad-spend fees. At Catalyst, we believe the most tangible way to drive growth for D2C brands is through mass creative production—balancing quality and quantity—paired with deep data insights. This approach enables constant learning, iteration, and ideation, allowing us to scale and improve results week after week. It's the foundation of what we do and why so many brands trust us to deliver growth."
                    </p>
                  </div>
                </foreignObject>
                <defs>
                  <filter id="filter0_d_121_1693" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse" height="252" width="366" x="0" y="0">
                    <feFlood flood-opacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" result="hardAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>
                    <feOffset/>
                    <feGaussianBlur stdDeviation="2.5"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0.321569 0 0 0 0 0.854902 0 0 0 0 0.458824 0 0 0 1 0"/>
                    <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_121_1693"/>
                    <feBlend in="SourceGraphic" in2="effect1_dropShadow_121_1693" mode="normal" result="shape"/>
                  </filter>
                </defs>
              </svg>
            </div>
          </div>
        </div>

        <!-- Desktop Content -->
        <div class="hidden lg:block">
          <p class="text-white text-[24px] lg:leading-[32px] lg:max-w-xl">
            Tobias has spent over $250 million across every digital platform. Building omni-funnel, multi-touchpoint performance strategies for some of the world's biggest brands.
          </p>
        </div>

        <button ref="buttonRef" class="cta-button mt-[1rem] lg:mt-[4rem]" style="z-index: 120; !important" @click="goToContactUs">
          <span class="text text-[12px] lg:text-[24px]">Book a call</span>
          <svg class="arrow hidden lg:block" fill="none" height="19" viewBox="0 0 35 19" width="35" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 9.27539H33.0682" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
            <path d="M25.8932 1L32.2859 7.39262C33.328 8.4347 33.328 10.1277 32.2859 11.1698L25.8932 17.5624" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
          </svg>
          <svg class="lg:hidden" fill="none" height="14" viewBox="0 0 25 14" width="25" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 7.27686H24" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.854 1.3418L23.4389 5.92672C24.1863 6.67413 24.1863 7.8884 23.4389 8.63581L18.854 13.2207" stroke="#52DA75" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
      <!-- Right Column -->
      <div class="hidden lg:block relative lg:ml-0 z-10 lg:z-0 w-full h-full lg:w-1/3 z-[1] -mr-[4rem] mt-[10rem]">
        <!-- Tobias Image -->
        <img
            alt="Tobias"
            src="../assets/meetTobias/img.png"
        />
        <div class="hidden lg:block absolute left-0 top-1/2 translate-y-1/2 -translate-x-1/2 z-5 lg:z-10">
          <div class="w-[138px] h-[138px] lg:w-[260px] xl:w-[316px] lg:h-[260px] xl:h-[316px] rounded-full flex flex-col items-center justify-center lg:z-20"
               style="background: linear-gradient(141deg, #D83B63 17.85%, #E248CE 137.74%);">
            <div class="flex">
              <span class="text-[20px] lg:text-[30px] xl:text-[50px] lg:leading-[80px] font-500 text-[#161816]">$</span>
              <span class="text-[30px] lg:text-[50px] xl:text-[70px] font-500 text-[#161816]">250mil</span>
            </div>
            <span class="text-[#161816] text-[11px] lg:text-[20px] xl:text-[24px] -mt-1 lg:-mt-4">Spent on digital ads</span>
          </div>
        </div>
      </div>
      <div class="hidden lg:block z-0 relative lg:w-2/5 z-[99]">
        <div>
              <img src="../assets/meetTobias/img_3.png" alt="Tobias">
          </div>
      </div>
    </div>
    <!-- Pink Circle -->
    <div class="flex lg:hidden w-full justify-end -mt-[5rem]" style="z-index: 99;">
      <img alt="tobias" class="w-2/3" src="../assets/meetTobias/img_2.png">
    </div>
  </section>
</template>

<script lang="ts" setup>
import {onMounted, ref, onUnmounted, watch} from 'vue'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {useRouter} from "vue-router";

gsap.registerPlugin(ScrollTrigger)

// Optimize GSAP defaults
gsap.defaults({
  force3D: true,
  willChange: 'transform, opacity'
})

const router = useRouter()
const sectionRef = ref<HTMLElement | null>(null)
const svgContainerRef = ref<HTMLElement | null>(null)
const mobileTextRef = ref<HTMLElement | null>(null)
const buttonRef = ref<HTMLElement | null>(null)
const titleRef = ref<HTMLElement | null>(null)
const mobileContentRef = ref<HTMLElement | null>(null)
const mobileContentHeight = ref('130px') // default small height
let scrollTrigger: ScrollTrigger | null = null
let observer: IntersectionObserver | null = null
let rafId: number | null = null
let isAnimating = false

const goToContactUs = () => {
  window.open("https://app.usemotion.com/meet/toby-green-bbrz/catalyst?d=30", "_blank");
};

function createMeetTobiasScrollTrigger() {
  if (!sectionRef.value || !svgContainerRef.value || !mobileTextRef.value || isAnimating) return

  isAnimating = true

  // Kill any existing ScrollTriggers
  if (scrollTrigger) {
    scrollTrigger.kill()
  }

  // Set initial states
  gsap.set(svgContainerRef.value, {
    opacity: 0,
    y: 20
  })
  gsap.set(mobileTextRef.value, {
    opacity: 1,
    y: 0
  })

  // Create a single timeline for better performance
  const tl = gsap.timeline({
    paused: true,
    defaults: {
      ease: 'none', // Use linear easing for better performance
      duration: 0.5
    }
  })

  // Single animation with fewer properties
  tl.to(mobileTextRef.value, {
    opacity: 0,
    y: -10,
    duration: 0.5,
    onStart: () => setMobileContentHeight(true)
  })
      .to(svgContainerRef.value, {
        opacity: 1,
        y: 0,
        duration: 0.5
      }, '-=0.3')

  // Create ScrollTrigger with minimal settings
  if (window.innerWidth < 1024) {
    scrollTrigger = ScrollTrigger.create({
      trigger: sectionRef.value,
      start: 'top top',
      end: '+=800', // Reduced distance for better performance
      pin: true,
      pinSpacing: true,
      anticipatePin: 1,
      scrub: 0.1, // Faster scrub for better performance
      fastScrollEnd: true,
      preventOverlaps: true,
      onEnter: () => {
        // Reset states
        gsap.set(svgContainerRef.value, {opacity: 0, y: 20})
        gsap.set(mobileTextRef.value, {opacity: 1, y: 0})
      },
      onUpdate: (self) => {
        // Throttle updates
        if (!rafId) {
          rafId = requestAnimationFrame(() => {
            tl.progress(self.progress)
            rafId = null
          })
        }
      },
      onLeaveBack: () => {
        // Reset on scroll back
        gsap.set(svgContainerRef.value, {opacity: 0, y: 20})
        gsap.set(mobileTextRef.value, {opacity: 1, y: 0})
        setMobileContentHeight(false)
      }
    })
  }
}

function killScrollTrigger() {
  if (scrollTrigger) {
    scrollTrigger.kill()
    scrollTrigger = null
  }
  if (rafId) {
    cancelAnimationFrame(rafId)
    rafId = null
  }
  isAnimating = false
}

const setMobileContentHeight = (showSvg: boolean) => {
  mobileContentHeight.value = showSvg ? '240px' : '130px';
}

onMounted(() => {
  if (window.innerWidth < 1024) {
    // Existing mobile observer code
    let timeoutId: number | null = null
    observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (timeoutId) {
          clearTimeout(timeoutId)
        }

        timeoutId = window.setTimeout(() => {
          if (entry.isIntersecting) {
            createMeetTobiasScrollTrigger()
          } else {
            killScrollTrigger()
          }
        }, 100)
      })
    }, {
      threshold: 0.1,
      rootMargin: '-10% 0px'
    })

    if (sectionRef.value) {
      observer.observe(sectionRef.value)
    }
  } else {
    // Desktop animations
    const desktopObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Create desktop animation timeline
          const desktopTl = gsap.timeline({
            defaults: {ease: "power2.out"}
          });

          // Animate Tobias image
          desktopTl.from(".hidden.lg\\:block img", {
            scale: 0.8,
            opacity: 0,
            duration: 1.2,
            ease: "power2.out"
          });

          // Animate pink circle
          desktopTl.from(".hidden.lg\\:block .rounded-full", {
            scale: 0,
            opacity: 0,
            duration: 1,
            ease: "back.out(1.7)"
          }, "-=0.4");

          // Create a separate observer for text visibility
          const textObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              const text = entry.target as HTMLElement;
              if (entry.isIntersecting) {
                gsap.to(text, {
                  opacity: 1,
                  y: 0,
                  duration: 0.8,
                  ease: "power2.out"
                });
              } else {
                gsap.to(text, {
                  opacity: 0,
                  y: 30,
                  duration: 0.5,
                  ease: "power2.in"
                });
              }
            });
          }, {
            threshold: 0.2,
            rootMargin: "-10% 0px"
          });

          // Observe text elements
          const textElements = document.querySelectorAll('.hidden.lg\\:block p');
          textElements.forEach(text => textObserver.observe(text));

          // Disconnect main observer after initial animation
          desktopObserver.disconnect();
        }
      });
    }, {
      threshold: 0.2
    });

    if (sectionRef.value) {
      desktopObserver.observe(sectionRef.value);
    }
  }
})

onUnmounted(() => {
  killScrollTrigger()
  if (observer) {
    observer.disconnect()
    observer = null
  }
})
</script>

<style scoped>
/* Optimize CSS for better performance */
.meet-tobias-section {
  position: relative;
  z-index: 1;
  contain: content;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  will-change: transform;
  isolation: isolate; /* Create stacking context */
}

.mobile-svg-container {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 366px;
  margin: 0 auto;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  will-change: transform, opacity;
  contain: layout style paint; /* Optimize rendering */
}

.responsive-svg {
  width: 100%;
  height: auto;
  aspect-ratio: 366/252;
  display: block;
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: transform;
  contain: layout style paint;
}

.transform-gpu {
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
  will-change: transform, opacity;
  contain: layout style paint;
}

.svg-text {
  width: 100%;
  height: 100%;
  overflow-y: auto;
}

.cta-button {
  background: #161816;
  color: white;
  border: 1px solid #ffffff;
  padding: 8px 16px;
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: fit-content;
}

.lg\:hidden {
  position: relative;
  z-index: 1;
  contain: content;
  transform: translateZ(0);
  backface-visibility: hidden;
  will-change: transform;
  isolation: isolate;
}

@media (min-width: 1024px) {
  .meet-tobias-section {
    contain: none !important;
  }
}

/* ... rest of styles ... */

.mobile-content-inner {
  transition: height 0.4s cubic-bezier(0.4, 0.0, 0.2, 1);
  will-change: height;
  position: relative;
}
</style>
